module.exports = __webpack_public_path__ + "img/radar-op.c8c5f432.gif";